import Vue from 'vue';
import App from './App.vue';
import router from './router';

// import jquery from 'jquery'
import bootstrap from 'bootstrap-vue';
import ElementUI from 'element-ui';

import './common/css/iconfont.css';
import './common/css/animate.css';
import 'element-ui/lib/theme-chalk/index.css';

// 动态添加title文本
router.beforeEach((to, from, next) => {
    console.log(to.meta.title);
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        // 如果当前路由有meta值
        document.title = to.meta.title;
    } else {
        // 如果没有meta值，就显示默认值
        document.title = '风领科技';
    }
    next();
});

Vue.config.productionTip = false;
// Vue.use(jquery)
Vue.use(bootstrap);
Vue.use(ElementUI);

new Vue({
    render: (h) => h(App),
    router,
}).$mount('#app');
